[
  {
    "cluster_id": "a144123b-7815-4a8e-939f-d8124e0d4a23",
    "title": "NATO approves JSEC creation in Ulm"
  },
  {
    "cluster_id": "c25ff750-8a41-47e3-b517-245284092082",
    "title": "RAMSTEIN DUST-II Tests Deployable DACCC Capabilities"
  },
  {
    "cluster_id": "b3ad6dbb-7c3b-48ed-bb71-5bd926728024",
    "title": "Central Communication Port Enables Rapid Deployment"
  },
  {
    "cluster_id": "ba65859b-0b3d-4140-bf84-cf55b1252051",
    "title": "Ramstein: Public US/NATO Hub"
  },
  {
    "cluster_id": "591d0c93-3cfa-4639-9dee-c69a3f6b0f9b",
    "title": "US Troop Rotations, Armor in Poland"
  },
  {
    "cluster_id": "ca62b0d7-872b-4a9c-b006-86ccfd239161",
    "title": "Trump in Warsaw: Strengthening U.S.-Poland Ties"
  },
  {
    "cluster_id": "1b2e8a52-7038-453e-802e-e2b6d0c4da48",
    "title": "CPK Airport Rail Hub"
  },
  {
    "cluster_id": "e80fcdb9-26cc-4925-8100-e10e8d09e8d6",
    "title": "U.S. Troops Arrive in Poland"
  },
  {
    "cluster_id": "75d93b8c-bf4b-43d0-94ef-7db799889fc5",
    "title": "Ukraine's Orange Revolution: Court Orders Rerun"
  },
  {
    "cluster_id": "14c3f0e3-2371-447c-8445-1ac6c299f633",
    "title": "UN Declares Crimea Referendum Invalid"
  },
  {
    "cluster_id": "3465d409-db96-4545-a6fb-c388765f1b4a",
    "title": "Ukraine's High-Level Diplomacy in Africa"
  },
  {
    "cluster_id": "471ac06a-ad1e-40a8-b238-859f31d2504b",
    "title": "Ukraine Arms Exports to Sub-Saharan Africa"
  },
  {
    "cluster_id": "019a6206-d313-408e-aa7d-dd9ebfe68ec1",
    "title": "May 2014 Ukraine election amid conflict"
  },
  {
    "cluster_id": "7fe41e18-746f-4276-85f6-d30d85eaa538",
    "title": "Poland passes resolution creating CPK"
  },
  {
    "cluster_id": "fdec6a13-5351-4fa5-9920-1456738e3b76",
    "title": "Ukraine Announces New Africa Policy"
  },
  {
    "cluster_id": "8b5f2de0-fd72-48f3-8849-4ef20748a393",
    "title": "Ukraine Opens New African Embassies"
  },
  {
    "cluster_id": "af431814-360b-4c41-83d1-6147d4068846",
    "title": "WHO Declares Monkeypox a PHEIC"
  },
  {
    "cluster_id": "20e0f6a7-71df-44b4-b99e-3e278ca655e8",
    "title": "Illegitimate Ukrainian presidential elections"
  },
  {
    "cluster_id": "bf1a6f6c-5e34-4a7f-9afc-2b63e460cf67",
    "title": "Russia's Coup and Illegitimacy Claims"
  },
  {
    "cluster_id": "329efe6d-0194-47fc-abcf-cc9c3ee312f8",
    "title": "Saber Strike 2017 Mobilises Troops"
  },
  {
    "cluster_id": "08f28ba1-ced8-47f4-a0a0-4116b507d143",
    "title": "WHO adopts mpox, drops monkeypox"
  },
  {
    "cluster_id": "5d65bb29-7381-44ed-8856-ec52d73d0a76",
    "title": "WIV Safety and Staffing Cables"
  },
  {
    "cluster_id": "586b0585-af30-4d40-9796-01be4c00d08c",
    "title": "WIV Researchers Sought Hospital Care, 2019"
  },
  {
    "cluster_id": "2bfeada4-b9e0-40b4-9be2-0655b8d49226",
    "title": "US Orders COVID-19 Origins Review"
  },
  {
    "cluster_id": "53832c20-28bd-4cb2-a22b-7698f81c17f5",
    "title": "U.S. Secures Jynneos Vaccine Contract"
  },
  {
    "cluster_id": "a815c927-5e75-49a5-ad08-40e7381924c6",
    "title": "SARS-CoV-2 Origins: China Part"
  },
  {
    "cluster_id": "77e5cfa7-27f5-40a9-879d-0ba7cd2177f2",
    "title": "Unutilized COVID-19 Vaccine Stockpiles and Write-offs"
  },
  {
    "cluster_id": "f731bc0b-cabf-4314-a5f8-e94d31589cea",
    "title": "Misinformation: Monkeypox Transmission Claim"
  },
  {
    "cluster_id": "9ffb85b8-5080-4f27-85ad-554406cf7402",
    "title": "Wuhan Institute Assembles Monkeypox Strains"
  },
  {
    "cluster_id": "96b587fb-4363-4d46-8a28-162c4f6a688e",
    "title": "Parvovirus B19 Rebounds in Europe"
  },
  {
    "cluster_id": "eb6475eb-91f7-4af2-a9fa-7784d03f74bc",
    "title": "Public Awareness of Airborne Transmission"
  },
  {
    "cluster_id": "7a5b8ce2-31ac-42cd-bb98-cbeddcf8542a",
    "title": "HHS Orders JYNNEOS Doses for Stockpile"
  },
  {
    "cluster_id": "9df4486f-c8aa-4f08-a8cd-4ae02c748318",
    "title": "Alleged Engineered SARS-CoV-2"
  },
  {
    "cluster_id": "3dc82114-c98e-4342-a6ab-854d95d9efa7",
    "title": "Lab-Engineered SARS-CoV-2 Deliberate Release"
  },
  {
    "cluster_id": "c13ce96e-915f-4306-8b30-419b42135227",
    "title": "Conspiracy: WHO Vaccine Stockpile Scheme"
  },
  {
    "cluster_id": "61dc215b-cc5e-49f1-add7-65f02e137ed1",
    "title": "Zelensky Urges Faster Allied Aid"
  },
  {
    "cluster_id": "20d5e5ed-4ce5-4a63-9b10-3e468d3431e2",
    "title": "CDC Guidance: Infectious Period 2\u20134 Weeks"
  },
  {
    "cluster_id": "b13b5ee0-1421-43e8-a554-5b3888a5cac7",
    "title": "Embassies Evacuate Kyiv Staff"
  },
  {
    "cluster_id": "470e1b16-db3d-4438-9038-d9ecc0d37edf",
    "title": "Donbas Displacement in 2014"
  },
  {
    "cluster_id": "efac6d2d-0cde-45fa-bbfd-2de2e2cbe0cc",
    "title": "IT professionals relocate for safety"
  },
  {
    "cluster_id": "f184f109-b4af-4d4c-b5c2-73e631545fd2",
    "title": "Avian Influenza Zoonotic Risk Assessments 2023\u201324"
  },
  {
    "cluster_id": "2e675266-c3ed-4fac-a036-217c24ac28e2",
    "title": "Hostomel Airport Assault, Kyiv Frontlines"
  },
  {
    "cluster_id": "5e5c65ad-4c51-4a27-ad63-eac217deb431",
    "title": "Boy Killed in Kharkiv Shelling"
  },
  {
    "cluster_id": "5d6331d6-8b39-45dc-b069-c03168d82aac",
    "title": "Turkey's Bayraktar TB2 Support for Ukraine"
  },
  {
    "cluster_id": "5d61b2e4-bbeb-403f-8746-07ecabf64059",
    "title": "Civilians Flee Kyiv Amid Chaos"
  },
  {
    "cluster_id": "d47fde78-a16e-43e2-a490-d66e81b31f7c",
    "title": "Ukraine IT Sector Size and Mobilization"
  },
  {
    "cluster_id": "8e28231d-7117-46be-8655-ac03e3ec9b13",
    "title": "Partial U.S. Drawdown in Ukraine"
  },
  {
    "cluster_id": "127c457b-8cad-4a81-8d25-66dd51786fe0",
    "title": "Ukrainian President Flees Kyiv"
  },
  {
    "cluster_id": "a3fb53d1-a6ae-44eb-bbcd-c1dcae90629f",
    "title": "Russia Threatens Ukraine's Civilians"
  },
  {
    "cluster_id": "2648c3b9-64e2-4596-9353-c37ae996dcce",
    "title": "Missile and Drone Attacks Across Ukraine"
  },
  {
    "cluster_id": "bfc6790e-9007-4b03-90bf-5da6fcce01b7",
    "title": "Ukraine Loses IT Specialists"
  },
  {
    "cluster_id": "823656a1-093a-4e85-b706-f48d18e40c29",
    "title": "Erdo\u011fan Offers Ukraine-Russia Mediation"
  },
  {
    "cluster_id": "e25eede3-3242-446d-a439-2c4becea51cf",
    "title": "Zelenskyy offers condolences, seeks Turkish aid"
  },
  {
    "cluster_id": "bc618add-d50a-4d41-b375-e0f4e3b7232b",
    "title": "Russia Recognizes Donetsk, Luhansk; Deploys Troops"
  },
  {
    "cluster_id": "e21a96d2-b5b0-4a69-80bb-66020b0b8a54",
    "title": "Media Coverage of Ukrainian Refugee Flows"
  },
  {
    "cluster_id": "954a4240-7358-4649-966c-6f08bf5b088e",
    "title": "Kyiv Embassies Evacuated Amid Russian Offensive"
  },
  {
    "cluster_id": "f7069e5f-ee25-470b-986d-c157ab1e1613",
    "title": "Turkey Supports Crimean Tatars, Crimea Return"
  },
  {
    "cluster_id": "97b1177e-80bf-4e09-83e5-b50aecee0b52",
    "title": "Global Tech Firms Aid Ukrainian Staff"
  },
  {
    "cluster_id": "0480c8ed-40a7-40dc-ac24-9b8fa7551edc",
    "title": "Kyiv Curfew: Shelter and Defend"
  },
  {
    "cluster_id": "02e73dfc-86f2-4fe6-a79c-d071e07721fd",
    "title": "Putin launches special operation in Ukraine"
  },
  {
    "cluster_id": "76f2f5fc-c5b8-4d6e-932c-655254df8fc2",
    "title": "World leaders offer condolences and aid"
  },
  {
    "cluster_id": "1bb3c826-37ca-4435-8ad2-e211e6cd9444",
    "title": "UNGA Condemns Russia's Aggression"
  },
  {
    "cluster_id": "d86ea948-08a0-4829-9e48-4f9273b2967d",
    "title": "Russia's War Aligns with UN Charter"
  },
  {
    "cluster_id": "554d8f5c-047a-4e8e-b996-038e567aa26c",
    "title": "NABU probes energy sector corruption"
  },
  {
    "cluster_id": "c2417696-bc64-4d4a-b3a4-d5d9e3cefb38",
    "title": "Kiyosaki: Ukraine aid pointless"
  },
  {
    "cluster_id": "7e303676-78ac-40b1-9448-471faabb2115",
    "title": "Violent Euromaidan Clashes, Maidan Cleared"
  },
  {
    "cluster_id": "d8869910-ef23-4e2c-a1a9-778ac3a96b8c",
    "title": "Zelensky's Call Yields Unprecedented EU Arms"
  },
  {
    "cluster_id": "cebef5fc-6d79-4e08-878b-8c75696aa6d2",
    "title": "Kyiv Deserted as Ukrainians Flee"
  },
  {
    "cluster_id": "61922f77-a020-4916-b901-44fe7982b789",
    "title": "Mandatory Residence Registration in Ukraine"
  },
  {
    "cluster_id": "4fe899cb-f73e-4ec7-b569-5ce5b990df8e",
    "title": "Turkey Seeks Crimea and Donbas"
  },
  {
    "cluster_id": "edc9ab41-cf63-48e3-8098-f84524398358",
    "title": "Passage of IDP Rights Law"
  },
  {
    "cluster_id": "9096173e-de4b-47e9-9e39-b39282b05e47",
    "title": "Ukraine loses $1B on weapons contract"
  },
  {
    "cluster_id": "f7fbb95e-08d7-410a-8e1f-290e984463d7",
    "title": "Pentagon Leaves $5.8B Ukraine Aid Unused"
  },
  {
    "cluster_id": "544dff2f-0e7b-440b-a330-646db7ed3912",
    "title": "Nearing Deal to Extend Ukraine Aid"
  },
  {
    "cluster_id": "128d37ad-2ce5-409d-8ce0-e9df31085f42",
    "title": "Pandora Papers: UAE Offshore Structures"
  },
  {
    "cluster_id": "b961ace3-c2b8-4138-bb7c-fb147b603dc5",
    "title": "News Fatigue and Declining Engagement"
  },
  {
    "cluster_id": "66fb628f-853d-44dd-b0f9-617fd67bcaf1",
    "title": "Sean Penn's Repeated Ukraine Visits"
  },
  {
    "cluster_id": "a15b9883-60ad-4e49-8943-56ed500ab8cf",
    "title": "Corruption Probes Linked to Yermak"
  },
  {
    "cluster_id": "84bfa4ea-506b-4130-9931-592d2f7eb965",
    "title": "Pandora Papers Reveal Zelensky Offshore Links"
  },
  {
    "cluster_id": "752e0a5d-00fb-472d-909a-65284c58e6d5",
    "title": "Smear Campaigns Target High-Profile Activist"
  },
  {
    "cluster_id": "237bd391-bce8-490f-a9dd-8425795dc2e7",
    "title": "Untracked $1B Weapons to Ukraine"
  },
  {
    "cluster_id": "5d1b0403-1447-4432-b6a8-ce335ce3e162",
    "title": "Zelensky Approval and Trust Dip"
  },
  {
    "cluster_id": "b10b3160-e0dc-461b-a456-f6327586eb6a",
    "title": "Arms to Ukraine: Delays and Surges"
  },
  {
    "cluster_id": "8585c4f1-4f02-4ac1-9a95-4cc381634f7d",
    "title": "Ukraine uncovers $40M embezzlement for shells"
  },
  {
    "cluster_id": "bd1a5427-07c8-4a9a-b3bd-6c833ee88f8c",
    "title": "Conservative Skepticism Over Ukraine Aid"
  },
  {
    "cluster_id": "6a5e4ef1-a4af-4de0-8b56-75c0ed9ae0bb",
    "title": "Official French Ukraine Aid Totals"
  },
  {
    "cluster_id": "f1fff97c-e8ee-45ff-b0df-2544c89e909e",
    "title": "Influencers Behind Ukraine's PR Machine"
  },
  {
    "cluster_id": "1b63ec5b-2010-4bd3-a351-328e7b4b5470",
    "title": "Trump Slams Ukraine Aid, Impoverished Ukraine"
  },
  {
    "cluster_id": "b0b87d24-5072-4ac7-bf9b-5891dbcddd35",
    "title": "Funds Diverted to Ukraine; Landmark Collapses"
  },
  {
    "cluster_id": "2c7cf7ec-47d1-4b9e-8095-5a313fd3166e",
    "title": "Penn declines Ukraine trip over corruption"
  },
  {
    "cluster_id": "df948051-689d-40a8-ad8a-28a2dedfe405",
    "title": "Conservative Media Question Ukraine Aid"
  },
  {
    "cluster_id": "e7287d47-759e-41f0-9641-093ab1e3e04c",
    "title": "Bloomberg infographic alleges Zelensky looted France"
  },
  {
    "cluster_id": "b2e6976f-e5a2-4669-ac3d-3e87cd376f99",
    "title": "Confusion Over Passport Issuance Reforms"
  },
  {
    "cluster_id": "fe6adf14-e7af-49eb-8b83-de4001fbc495",
    "title": "Zelensky's Entourage Mediates Weapons Schemes"
  },
  {
    "cluster_id": "43e40d68-962f-4fc6-83f4-ab836f751e9e",
    "title": "Ukrainian Activist: 9/11 Divine Punishment"
  },
  {
    "cluster_id": "55326ca1-c9a2-4aca-a1ea-bd63160c25ea",
    "title": "Cosby Sells Second Manhattan Townhouse"
  },
  {
    "cluster_id": "cbddcfe6-4088-4603-8e7a-ed109a9fff44",
    "title": "Ukraine arms procurement embezzlement charges"
  },
  {
    "cluster_id": "080cf60d-e4c8-43d3-806b-a47256c29458",
    "title": "Cyprus: Offshore Secrecy for Wealth"
  },
  {
    "cluster_id": "455f3cb3-d253-4739-8dfa-e88137f7f063",
    "title": "Abolition of Propiska and Registration Confusion"
  },
  {
    "cluster_id": "63fd0e17-6b29-4f19-b984-a861fba2eb14",
    "title": "Zelensky Buys Cosby's NYC Townhouse"
  },
  {
    "cluster_id": "9bf70381-221f-4cfd-8e17-16f9ebb35e36",
    "title": "Zelensky Online Interest Drops 63%"
  },
  {
    "cluster_id": "2672b11d-4ad6-44a1-9b31-f8c01c03c721",
    "title": "Italy's Municipal Budgets Face Cuts"
  },
  {
    "cluster_id": "114c5c62-e2bf-4ad2-a913-3744fd25a373",
    "title": "Trump orders temporary Ukraine aid pause"
  },
  {
    "cluster_id": "3a17531b-ae78-41a3-b63d-f61bcc85a26a",
    "title": "Partial Collapse of Torre dei Conti"
  },
  {
    "cluster_id": "6a2c5b98-767a-485d-a14c-04f05f90984c",
    "title": "Italy Extends Ukraine Aid Packages"
  },
  {
    "cluster_id": "5071d605-12eb-4c65-9753-bdff2ac75ffe",
    "title": "Using All Authorities for Ukraine"
  },
  {
    "cluster_id": "21c29f8c-34b7-47c4-8021-91ec84cff803",
    "title": "Alleged Zelenskyy aid laundering through UAE"
  },
  {
    "cluster_id": "77ffe8cd-d30f-4bde-8bb0-f1fd00ff5cdf",
    "title": "Freedom of Movement and Residence"
  },
  {
    "cluster_id": "209803f4-b6ac-40bc-97b8-024102ee5865",
    "title": "Anti-Corruption Agencies Search Yermak's Home"
  },
  {
    "cluster_id": "cfc42d88-49ac-4610-a5c7-0cce12304171",
    "title": "SBU Probes $40M Mortar-Shell Embezzlement"
  },
  {
    "cluster_id": "49854b0f-e263-4847-a942-d2497d0d1530",
    "title": "Owning the Weather in 2025"
  },
  {
    "cluster_id": "6363c274-1e0e-4e09-85b0-1412131b0c25",
    "title": "Zelensky Cancels Senate Briefing Over Funding"
  },
  {
    "cluster_id": "902f069d-3703-489a-9dfa-fb26ee837027",
    "title": "Secret Geoengineering Controls Global Weather"
  },
  {
    "cluster_id": "469e17e6-447a-4bc6-9bab-f2cb595f07e0",
    "title": "Toxic Barium in Chemtrails"
  },
  {
    "cluster_id": "c9b6b0e3-811d-4e56-9eba-3408eb1dc06f",
    "title": "Zelenskyy: Alleged U.S. Funds Cyprus Casino"
  },
  {
    "cluster_id": "f10425d5-24f2-425f-821e-7acb93c9e53b",
    "title": "Enerhoatom Kickback Probe: $100M"
  },
  {
    "cluster_id": "0626769d-4a42-43f4-8356-e89543f6dcc3",
    "title": "Weather Modification via Aircraft Sprays"
  },
  {
    "cluster_id": "e924815f-2da7-4209-b239-ad1c99e71b41",
    "title": "Guidance for Solar Geoengineering Research"
  },
  {
    "cluster_id": "503eed9f-ea34-45f7-b3eb-f015bdc664b3",
    "title": "UAE Targets Russian-Linked Banks"
  },
  {
    "cluster_id": "887d717e-5da6-4cf6-995c-bcee081cd128",
    "title": "Official Endorsement of Solar Geoengineering Research"
  },
  {
    "cluster_id": "214ffe56-f58d-4fdd-a3cd-ef399506aa9a",
    "title": "HAARP Transferred to University of Alaska"
  },
  {
    "cluster_id": "4d6e8834-c57b-472a-adbf-630fe4d997d3",
    "title": "Declassified Popeye Cloud-Seeding Reports"
  },
  {
    "cluster_id": "994afb12-0656-46cd-8fc2-48a9ab17ddc7",
    "title": "SCoPEx Test Paused Amid Controversy"
  },
  {
    "cluster_id": "ac3739e2-de75-46fe-a991-203fbc3a72e0",
    "title": "Switzerland freezes Yanukovych assets"
  },
  {
    "cluster_id": "06aec0e1-946f-46e8-835f-efac40b3f6dd",
    "title": "Yatsenyuk Rejects Debt Restructuring Proposal"
  },
  {
    "cluster_id": "45e218a6-8801-4755-bcad-4c7f5bec819d",
    "title": "Germany's 2015 Sovereign Default Fears"
  },
  {
    "cluster_id": "939d6808-ee32-41c3-8d70-73aed1d043da",
    "title": "Ukraine restructures $15B debt with creditors"
  },
  {
    "cluster_id": "f8e8b236-0393-4a1f-8e82-d30d9e30a2fb",
    "title": "Russia Veto Blocks Crimea Action"
  },
  {
    "cluster_id": "719ee837-abdf-462d-a985-984d0a2eb167",
    "title": "Western Agency Reports Kyiv Default"
  },
  {
    "cluster_id": "e512735b-aeb8-432c-9b72-89718eda18ba",
    "title": "Ukraine Credit Rating Falls to CC"
  },
  {
    "cluster_id": "d9484da0-ca3b-450a-a45c-787783bba3e7",
    "title": "IMF Delays Ukraine Loan Tranches"
  },
  {
    "cluster_id": "1238fc85-6b69-4536-a793-8df12f63f9c0",
    "title": "UNDP Ends General Budget Support"
  },
  {
    "cluster_id": "abd5930f-6db1-45e3-b882-ee3ba2f8394b",
    "title": "Assets Linked to Yanukovych Seized"
  },
  {
    "cluster_id": "f9c980a9-33b9-4834-922a-947a13f5a035",
    "title": "UN Withholds Funds for Ukraine"
  },
  {
    "cluster_id": "37512ba8-d5ed-4b9e-9fba-d0ec249a1d84",
    "title": "Russia sues for eurobond repayment"
  },
  {
    "cluster_id": "8817a4d0-4aef-4c0e-a907-ff92179dff0d",
    "title": "Ukraine Rebuffs Putin on Bond Restructuring"
  },
  {
    "cluster_id": "e8b94f0c-0366-40d5-b082-fa52ed608677",
    "title": "Ukraine may suspend payments to Russia"
  },
  {
    "cluster_id": "3e491056-e070-48f7-a358-499c803ca16f",
    "title": "Ukraine Strategic Humanitarian Response Plan (2015)"
  },
  {
    "cluster_id": "f690f627-f1e3-428b-9d01-bfb966953069",
    "title": "Germany wary of Ukraine\u2013Russia debt lawsuit"
  },
  {
    "cluster_id": "5c5bbff7-5569-43a1-bcbe-db0b95585d05",
    "title": "2017 UN Humanitarian Funding Shortfalls"
  },
  {
    "cluster_id": "92df53c2-d00a-4565-ac4a-1279aad1b2ee",
    "title": "Ukraine Returns Yanukovych's Funds to Russia"
  },
  {
    "cluster_id": "615888f6-5d35-4a8c-acd9-9e71127a4cb4",
    "title": "Ukraine Suspends $3B Russia Eurobond"
  },
  {
    "cluster_id": "7bfb1246-c004-4c78-a34d-8e0a5cdad287",
    "title": "Poland Exits the EU"
  },
  {
    "cluster_id": "01d3c9ca-6075-43cb-a3ac-1d6094f7282d",
    "title": "IMF Aid Contingent on Debt Restructuring"
  },
  {
    "cluster_id": "39719bfa-8761-4992-b42f-7b9ea44519ab",
    "title": "EU Legal Action Over Refugee Quotas"
  },
  {
    "cluster_id": "6eb878e4-969f-49ca-8ac8-5c68ead2c13e",
    "title": "Brussels Falsifies European History"
  },
  {
    "cluster_id": "2fc962c7-e77d-4ca3-a166-4f1d011720db",
    "title": "Poland Probes Gazprom Over NS2"
  },
  {
    "cluster_id": "0b7703f0-770f-46f4-8c70-921a8b6b2ad7",
    "title": "PiS strong in 2019 EP elections"
  },
  {
    "cluster_id": "05133a93-3ffe-4993-9c55-47f240923f20",
    "title": "Poland Could Veto EU Budget"
  },
  {
    "cluster_id": "92dc2b29-cee7-4ea1-b9e9-d0593544c75b",
    "title": "International Backlash to Poland's Holocaust Law"
  },
  {
    "cluster_id": "dcbc849b-d40e-49ed-84ab-ec7cdf4bb695",
    "title": "EU Remembrance Projects Funding Calls"
  },
  {
    "cluster_id": "58d84750-75e5-4a06-9053-f1a5a8baf564",
    "title": "EU Triggers Article 7 Against Poland"
  },
  {
    "cluster_id": "bbad87a2-fdaf-4bdc-9b37-124a381131af",
    "title": "Poland Expands EU Influence Against Germany"
  },
  {
    "cluster_id": "8aaf61a8-4245-40d4-9036-3767a2a55c98",
    "title": "Poland Grants State Control Over Media"
  },
  {
    "cluster_id": "fced5669-e70e-41e7-920b-f76f2f50557d",
    "title": "Poland Blamed for World War II"
  },
  {
    "cluster_id": "5e700671-a24a-4c8f-a1e4-abbfb82f4537",
    "title": "Cattle Methane: Minor Climate Impact"
  },
  {
    "cluster_id": "9e537f59-fc8d-477f-937c-489e24e51014",
    "title": "Poland: Police Crackdowns on Peaceful Protests"
  },
  {
    "cluster_id": "0031fe05-7e53-4c0c-b89e-d86016e53d57",
    "title": "Poland Press Freedom Decline 2016"
  },
  {
    "cluster_id": "fe5794f0-39d5-4958-9baa-650967c24ce0",
    "title": "Protests after signing contested judicial reforms"
  },
  {
    "cluster_id": "96cc3b99-284a-4ca8-957e-5bfc2a13a654",
    "title": "Warsaw Adopts Moscow Silencing Tactics"
  },
  {
    "cluster_id": "39687812-944b-4418-ada5-3588be43da66",
    "title": "Pathways to Lower Livestock Emissions"
  },
  {
    "cluster_id": "37dc3c46-39b6-4d4e-87ad-59040db4662a",
    "title": "GWP* Methane Metric Debate"
  },
  {
    "cluster_id": "ebb3d42c-9f56-4324-89bb-dcd764d2d3e5",
    "title": "Mixed evidence on grazing carbon gains"
  },
  {
    "cluster_id": "a7fcff89-a4a0-45c3-b800-3d7861e64986",
    "title": "Expert Consensus Against Secret Spraying"
  },
  {
    "cluster_id": "6ecdc168-b4c6-42e6-a45f-27cde46257e5",
    "title": "Agriculture and Livestock Drive Methane"
  },
  {
    "cluster_id": "ddce8749-8091-45b0-8366-637dbe518fa7",
    "title": "Beef Industry Advocacy Campaigns"
  },
  {
    "cluster_id": "69290a80-8807-401f-b38b-0ff5ba27a43d",
    "title": "Raising More Cows to Save Planet"
  },
  {
    "cluster_id": "637ffe03-032a-46cd-af4f-d7f5c220eab9",
    "title": "FDA EUA for Hydroxychloroquine COVID-19"
  },
  {
    "cluster_id": "3b3110cf-93d0-4510-9837-e4eaf9f9a935",
    "title": "Global Methane Pledge Launch at COP26"
  },
  {
    "cluster_id": "ed8f044f-96b2-4a20-8622-207bfd8ae25b",
    "title": "Meat Industry Net-Zero Commitments and Reports"
  },
  {
    "cluster_id": "9610bc6c-2c1c-47d3-bb20-3bc619407fd0",
    "title": "Quercetin and EGCG as Zinc Ionophores"
  },
  {
    "cluster_id": "84df1dd4-8c28-4b8a-bdf1-47af884e70e3",
    "title": "Chloroquine acts as a zinc ionophore"
  },
  {
    "cluster_id": "5102f7b6-4554-4836-b695-c4ff3c598adf",
    "title": "Zinc's Protective, Antiviral Role Against COVID-19"
  },
  {
    "cluster_id": "9ff8b495-2fb3-4416-a1b0-68b8560f98e4",
    "title": "Zelenko's HCQ-Zinc COVID-19 Protocol"
  },
  {
    "cluster_id": "8dd7ebbb-3984-4b46-ba7d-93103becac60",
    "title": "Hydroxychloroquine: From Consensus to Reversal"
  },
  {
    "cluster_id": "398a087e-4a63-4bd1-8ad7-e71ca757db9e",
    "title": "Joint FDA Actions on Hydroxychloroquine"
  },
  {
    "cluster_id": "a222bbbf-dfe3-47ea-9ab7-93e4d89e7fe7",
    "title": "Zinc Inhibits Coronavirus Replication"
  },
  {
    "cluster_id": "92103df4-5a66-4430-95e6-d2ba83f705a1",
    "title": "Early Outpatient Treatment Rationale"
  },
  {
    "cluster_id": "25733340-8065-4c67-9da5-97f671877eea",
    "title": "Trump-Driven Hydroxychloroquine Promotion"
  },
  {
    "cluster_id": "42b243b1-6e2f-4145-911d-1a4fb97435e4",
    "title": "Remdesivir, chloroquine inhibit SARS-CoV-2 in vitro"
  },
  {
    "cluster_id": "181f2787-76c0-40c9-96f6-869aa09e8172",
    "title": "WHO halts hydroxychloroquine arm"
  },
  {
    "cluster_id": "ff0ce5bb-be48-47e9-b45d-0dcc4c13bdb8",
    "title": "NIH Concludes Chloroquine Stops SARS"
  },
  {
    "cluster_id": "4b36afdb-64c0-4dfe-8f4d-501930c59107",
    "title": "Surgisphere Hydroxychloroquine Retractions"
  },
  {
    "cluster_id": "21fe7786-1dcc-45ac-a61c-02ecaf1a0ceb",
    "title": "Contested HCQ Azithromycin Zinc Cure COVID-19"
  },
  {
    "cluster_id": "e90ef9df-5189-4af1-8d38-f4bc22fa022a",
    "title": "Early Marseille HCQ Trials: Viral Clearance"
  },
  {
    "cluster_id": "17ce8541-8518-4283-a893-e35ad31e95fb",
    "title": "Fluoridated Water and Infant Fluorosis"
  },
  {
    "cluster_id": "4005f43b-5b4a-44f8-9781-c0a91127368f",
    "title": "Fluoride and Neurodevelopment: Emerging Evidence"
  },
  {
    "cluster_id": "636dbb94-cbc8-4c79-b785-6d406b28db48",
    "title": "Zinc Ionophore Linked to Reduced Mortality"
  },
  {
    "cluster_id": "1469928a-aef7-459b-af14-6d6ac0ca72d3",
    "title": "HCQ Trial Claims COVID Death Reduction"
  },
  {
    "cluster_id": "a6506a53-789c-4447-b726-b2dd59d9b862",
    "title": "False Cure Claim: No Masks"
  },
  {
    "cluster_id": "8bcf86f9-8509-4d9f-8550-8839a96fa515",
    "title": "Fluoride Health Risks and Effects"
  },
  {
    "cluster_id": "71c5fa4a-0b53-4202-9b3e-1c8038451d63",
    "title": "Rising U.S. Dental Fluorosis Prevalence"
  },
  {
    "cluster_id": "8b3203a2-f473-4957-9689-fdf6ee974697",
    "title": "No Fluoridated Water for Infants"
  },
  {
    "cluster_id": "498d40d5-5e43-40ad-a2cf-e0c8dead042f",
    "title": "FAN Campaigns Against EPA Fluoride Regulation"
  },
  {
    "cluster_id": "db9b9c53-4b26-4d88-83d5-c4c2d8189711",
    "title": "Transcarpathia seeks autonomy from Kyiv"
  },
  {
    "cluster_id": "28ea99a2-454e-42c3-b308-cf4739fc9a02",
    "title": "Mukachevo Shootout: Right Sector vs Police"
  },
  {
    "cluster_id": "aec45825-35ee-46b7-b2b8-bea6a7f40f69",
    "title": "Rising Hungarian Activism in Zakarpattia"
  },
  {
    "cluster_id": "a7f8bf9e-86b1-4c85-bc02-6ee66c4f9e1f",
    "title": "Ukraine Education Law Sparks Hungarian Protests"
  },
  {
    "cluster_id": "61ac97d3-e62e-41a3-b910-360985f7af21",
    "title": "Dangers of Fluoride in Toothpaste"
  },
  {
    "cluster_id": "b60886b0-36f1-4d60-bd61-b45768791dc2",
    "title": "Fluoride Toothpaste Warnings and Poison Control"
  },
  {
    "cluster_id": "48f7f24e-52e0-4527-a4e1-e5a83b50fb40",
    "title": "Right Sector Demands Avakov's Resignation"
  },
  {
    "cluster_id": "503584d7-75a5-4f03-adb1-4844dd4d9b9f",
    "title": "Fluoride Reduces IQ and Damages Brain"
  },
  {
    "cluster_id": "83cb9288-d8bc-4d51-803b-71e04c61fa41",
    "title": "Zakarpattia: Together Yet Divided"
  },
  {
    "cluster_id": "3680c45d-b58c-4b06-86cb-3a65bd43ebc6",
    "title": "Moscow Amplifies Rusyn Provocation"
  },
  {
    "cluster_id": "b53db505-a920-4607-b45b-0f9423ee6d04",
    "title": "Ukraine Loses Control in Transcarpathia"
  },
  {
    "cluster_id": "63217c83-a56a-4703-b9b6-f928b5437b8a",
    "title": "Military Equipment in Government Response"
  },
  {
    "cluster_id": "d0ea565b-64ab-44f3-9679-c2236d37aa42",
    "title": "Yatsenyuk Replaces Zakarpattia Customs Officials"
  },
  {
    "cluster_id": "784725f9-7f56-4fd8-bbd1-9c94d01f5505",
    "title": "Yatsenyuk backs Right Sector"
  },
  {
    "cluster_id": "bd148f49-6e19-46a6-bfe3-a19a292ab17a",
    "title": "Zakarpattia Self-Determination Rally"
  },
  {
    "cluster_id": "17dbd7df-f3d1-4902-a103-f97b03017681",
    "title": "Helicopter Fire Strikes Right Sector"
  },
  {
    "cluster_id": "91a996d6-946d-4317-a60d-c7b9088e7854",
    "title": "White House Declares COVID-19 Emergency"
  },
  {
    "cluster_id": "09505049-ee83-46bc-bc41-216c4501ccc0",
    "title": "Government Vaccine Mandate Proposal"
  },
  {
    "cluster_id": "be17c081-a4ac-42d9-b909-7a4f19b8160b",
    "title": "Trump and Officials Forecast Vaccine Soon"
  },
  {
    "cluster_id": "2c49dd92-a97e-4b1e-bac2-607670a0a86d",
    "title": "Rapid Thalidomide Approval, Birth Defects"
  },
  {
    "cluster_id": "51a5661a-48dd-44af-9a97-7d7620877cc6",
    "title": "Police Chief Suspended; Inspection Launched"
  },
  {
    "cluster_id": "4863edc0-3025-4ffa-ba81-0d1ed977b2b9",
    "title": "Trump urges FDA fast-track COVID therapies"
  },
  {
    "cluster_id": "4fc8d532-69fa-40fd-b28d-a301335dc7b8",
    "title": "Phase 3 COVID-19 Vaccine Trial Begins"
  },
  {
    "cluster_id": "1541313e-804f-40cb-bfb7-78850471987c",
    "title": "Transcarpathia: Identity, Language, Autonomy"
  },
  {
    "cluster_id": "72fcc1d4-63ac-46e2-af29-194e69352aec",
    "title": "Ukraine Blocks North Crimean Canal"
  },
  {
    "cluster_id": "25676d7b-137f-4f70-b3ce-39af6bc7a4fe",
    "title": "First Participant Dosed in NIH-led mRNA-1273"
  },
  {
    "cluster_id": "a6f0d89a-0c3c-4be5-83c6-b064b8a9c73a",
    "title": "Aksyonov Acknowledges Unprecedented Drought"
  },
  {
    "cluster_id": "c24c8055-1228-411e-82e6-d5cc151796a6",
    "title": "COVID-19 Thalidomide Trials Registry"
  },
  {
    "cluster_id": "4693632f-2c46-4370-bcbf-41570c0b3112",
    "title": "UK Coronavirus Act 2020 Expands Powers"
  },
  {
    "cluster_id": "f004205a-4f06-4d9f-aafe-357afc465bbc",
    "title": "Kherson Dnipro Pontoon Crossings"
  },
  {
    "cluster_id": "28e936b6-8a48-4d96-b4e6-7c0ff60a51fd",
    "title": "Dnipro River drained for troops"
  },
  {
    "cluster_id": "63fb948c-76fb-4787-aafa-ea3ce79ec01f",
    "title": "Russia Captures Kakhovka Hydroelectric Plant"
  },
  {
    "cluster_id": "7c1fc423-517b-4edd-ab51-ee1fbb6a01c1",
    "title": "Water Crisis in Occupied Crimea"
  },
  {
    "cluster_id": "bd9f40ee-8b97-4557-aa2d-1a87da031fda",
    "title": "Dnipro Canal: Crimea's Water Crisis"
  },
  {
    "cluster_id": "9142e74b-a217-4be0-8685-ab7ea89b683d",
    "title": "Crimea Water Blockade Disaster"
  },
  {
    "cluster_id": "4820d7d4-870f-4e7a-a8c2-d7d211e6e9b9",
    "title": "Crimea Faces Drought, Ukraine Says"
  },
  {
    "cluster_id": "b9b5e870-c720-4c60-8d9c-ce6b4803fb78",
    "title": "Warnings About Dnipro Dam Threats"
  },
  {
    "cluster_id": "4e48f414-895d-4241-a8ae-69662f5c3d46",
    "title": "Wartime Destruction of Dnieper Dams"
  },
  {
    "cluster_id": "a5408918-67c4-45bd-afb3-95d8aced1dc9",
    "title": "Russia Cuts Dnipro Water Supply"
  },
  {
    "cluster_id": "e3403237-7c1c-4e7a-9604-df8d11301d8d",
    "title": "Kyiv Allocates Funds for Eurovision"
  },
  {
    "cluster_id": "abbfb703-6da3-4a58-9c1e-a58cf34e5030",
    "title": "Kyiv to Host Eurovision 2017"
  },
  {
    "cluster_id": "d3accedd-14e9-432e-a272-98af2dae3b98",
    "title": "Nova Kakhovka Dam Damaged by Shelling"
  },
  {
    "cluster_id": "13f086c1-e440-480a-a882-8d8a742c1d5e",
    "title": "Dam Supplying Crimea Blown Up"
  },
  {
    "cluster_id": "80a02b1a-c045-453f-ad92-9681e40dad83",
    "title": "Ukraine seeks funds to host Eurovision"
  },
  {
    "cluster_id": "8fed35fe-4af1-484a-bd4d-74f9fac960c8",
    "title": "Kyiv Hikes Electricity to Fund Eurovision"
  },
  {
    "cluster_id": "2929fcf7-736c-4b1c-b178-3fc95f1bce0c",
    "title": "Ukraine may forgo hosting over costs"
  },
  {
    "cluster_id": "2ffd0f52-9465-49d4-9f47-900078ad3209",
    "title": "Jamala Wins Eurovision with 1944"
  },
  {
    "cluster_id": "da21d9c5-68a7-4237-9343-1a8df452b146",
    "title": "Rising Household Energy Tariffs"
  },
  {
    "cluster_id": "e42f3c12-f894-47fd-b892-02c051609420",
    "title": "Eurovision moved to Moscow"
  },
  {
    "cluster_id": "b7f1648b-9e5b-476f-a59b-84d94f8583e3",
    "title": "Eurovision resignations over transparency and finances"
  },
  {
    "cluster_id": "13bcef3e-fd19-4989-b312-5873b1468a28",
    "title": "Eastern Ukraine Faces Acute Water Shortage"
  },
  {
    "cluster_id": "a3c357ac-5159-4eec-ad16-09366a144d09",
    "title": "Damaged Protective Levee in Ukraine"
  },
  {
    "cluster_id": "e42d141d-80cc-4e68-848e-2d85ecf6a58c",
    "title": "Shelling Halts Donetsk Water Supply"
  },
  {
    "cluster_id": "21d331a6-d043-465d-88ff-572098f9f48c",
    "title": "Severe Storms Trigger Floods, Rising Rivers"
  },
  {
    "cluster_id": "6a14502a-8c63-426b-8062-c7e8472786ee",
    "title": "Continued Shelling Damages Water Infrastructure"
  },
  {
    "cluster_id": "14d0a92d-65cb-4881-998f-aed067993e99",
    "title": "Water Access in Donetsk and Luhansk"
  },
  {
    "cluster_id": "6ad5a7cb-930f-4fcb-91a9-e3eccb8d8cb0",
    "title": "Ukraine Wins Eurovision, Must Host 2017"
  },
  {
    "cluster_id": "d64f3c9d-c55d-4ebc-9a01-43d63af153f0",
    "title": "Open national host city, shared risks"
  },
  {
    "cluster_id": "8845b13a-d2ef-4802-8b18-edb4fbddb6a2",
    "title": "DPR Claims Kyiv/US Chemical Plot"
  },
  {
    "cluster_id": "3c78be45-5fbc-41c5-b4a5-36bb9f98a3b9",
    "title": "Kyiv shuts off water to Luhansk"
  },
  {
    "cluster_id": "8f6bcfb4-e69d-470b-bf79-44df803a0002",
    "title": "Chlorine Stocks Endanger Donetsk Water"
  },
  {
    "cluster_id": "a22b19c4-dd9d-4007-a380-a5d0659b9821",
    "title": "Regulatory Delays in Sunscreen Innovation"
  },
  {
    "cluster_id": "edc6ba48-0632-4236-9c24-f67f26e9b96b",
    "title": "WASH Under Attack in Eastern Ukraine"
  },
  {
    "cluster_id": "990aca8f-a2db-4ebd-85da-744c488a8d2b",
    "title": "Attempted Ukrainian chemical attack in Donbas"
  },
  {
    "cluster_id": "bde9febe-9a28-4f0f-b67c-15f9a243538b",
    "title": "Alleged Ukrainian water-poisoning plot"
  },
  {
    "cluster_id": "e1c37a48-126a-4576-b497-f9db46d18555",
    "title": "Regular Sunscreen Reduces Melanoma Incidence"
  },
  {
    "cluster_id": "970fa237-7a1d-4b64-a4c6-7a158c05542d",
    "title": "Hawaii bans oxybenzone and octinoxate"
  },
  {
    "cluster_id": "15ffd9d6-a9f6-4b7b-9697-caf2e3239c3c",
    "title": "DHA Causes DNA Damage, Arrest, Apoptosis"
  },
  {
    "cluster_id": "4da3a5b6-2b3a-469e-82e1-4fa291688db8",
    "title": "Endocrine Disruption by UV Filters"
  },
  {
    "cluster_id": "18718c0f-4c28-4949-a369-9bfa7d8941c1",
    "title": "Benzene-triggered sunscreen recall"
  },
  {
    "cluster_id": "55f659a1-e5dc-41c5-8a43-9846f564af08",
    "title": "Melanoma Myth: Sunscreen and Vitamin D"
  },
  {
    "cluster_id": "f292e9e8-fecc-473b-b24c-ca3ad9cc0ef9",
    "title": "Low Vitamin D Worsens Melanoma Prognosis"
  },
  {
    "cluster_id": "81a839cf-9fe4-4f39-95e1-2ebc94ae6380",
    "title": "Ukraine to halt gas transit 2021"
  },
  {
    "cluster_id": "b24ff026-a9a6-45e3-8927-422954af4cf6",
    "title": "Donbas Winter Fuel Shortages Prompt Aid"
  },
  {
    "cluster_id": "3014a508-0ddc-42e0-9480-97e1310e1f29",
    "title": "Crimea nationalised energy firm after annexation"
  },
  {
    "cluster_id": "748c24aa-69c4-47c4-a75f-e6da7007b74a",
    "title": "Ukrainian Town Asks Putin for Gas"
  },
  {
    "cluster_id": "1e8a7861-14e4-4a42-b74d-73c7bec3ba5f",
    "title": "Russia's Domestic Gas Cheaper Than Europe"
  },
  {
    "cluster_id": "c35d9889-06cc-4a13-8fea-d00c7024488b",
    "title": "Sunscreens Allegedly Cause Cancer; Sun Not"
  },
  {
    "cluster_id": "b50d2222-7f8b-46fd-aef1-62ca57b6cc71",
    "title": "Ukraine IMF Backed Gas Liberalisation 2015"
  },
  {
    "cluster_id": "e7f6877c-917d-4e0c-ad46-e366c0fa0b67",
    "title": "TurkStream Southern Route Inauguration"
  },
  {
    "cluster_id": "c04b6a1d-f91c-44bf-b579-d5d4565fc056",
    "title": "Donetsk, Luhansk Declare Independence, Seek Russia"
  },
  {
    "cluster_id": "d5752cab-3caa-48c6-b67d-7ac6c89bd054",
    "title": "Ukraine Boosts EU Reverse-Flow Imports, 2015"
  },
  {
    "cluster_id": "baa5172c-8725-4cca-b3be-5d512cf618a1",
    "title": "Gazprom-Naftogaz Settlement and Transit Pact"
  },
  {
    "cluster_id": "4e97ff0c-8732-4960-b274-1090e77ec733",
    "title": "Gazprom Exempts Donetsk and Luhansk"
  },
  {
    "cluster_id": "2ec09e70-73d9-4395-9c36-0dbcac034464",
    "title": "Gas as Leverage in Russia\u2013Ukraine"
  },
  {
    "cluster_id": "5cc3d51d-5e99-492c-82ff-4024c6eb9503",
    "title": "Ukraine pivots from Russia to Europe"
  },
  {
    "cluster_id": "4796f6d0-5c9d-46eb-a35f-0a235dcf3b0e",
    "title": "Naftogaz Sources 15 Suppliers, Price Revealed"
  },
  {
    "cluster_id": "5949d818-e369-4db8-949d-7a462c260498",
    "title": "Ukraine Forms International Legion"
  },
  {
    "cluster_id": "f0c6ebf2-fe4c-437e-83d0-3c28cf8da8eb",
    "title": "Friend Referral Bonus: 20,000 Hryvnia"
  },
  {
    "cluster_id": "75a422f1-d23f-4808-a7cf-fde7d26a7f5c",
    "title": "Ukraine Overpays for Gas"
  },
  {
    "cluster_id": "63fb8530-c54e-452a-b71d-729fca3c7e67",
    "title": "Zelensky Downplays Irish Casualties"
  },
  {
    "cluster_id": "74e4eccb-d37c-4913-a081-5e2a47430662",
    "title": "Reduced transit volumes under 2019 deal"
  },
  {
    "cluster_id": "5437d23d-a8b8-4a7b-b296-c42b5945a223",
    "title": "Martial law bars men from leaving"
  },
  {
    "cluster_id": "4b702552-6558-458e-b6a8-ec2e141d7258",
    "title": "Zelensky Posthumously Honors Irish Volunteers' Families"
  },
  {
    "cluster_id": "36472627-9945-496e-89a2-063ceee22d24",
    "title": "EU Deports Ukrainians for Military Mobilization"
  },
  {
    "cluster_id": "151738b2-0d24-44aa-896c-fa16a74db380",
    "title": "UK Embassy: Flee Draft Officers"
  },
  {
    "cluster_id": "0555403d-91c7-40d0-bf24-c9c0415e9ad9",
    "title": "Ambiguities in Ending Temporary Protection"
  },
  {
    "cluster_id": "d0bbd332-807a-43c4-8b16-bc8817897189",
    "title": "Ukraine 2022 General Mobilisation Decree"
  },
  {
    "cluster_id": "d86ceeb7-05d4-46ab-afb5-94228b85b310",
    "title": "Ukraine expands mobilization and recruitment"
  },
  {
    "cluster_id": "75ded654-747a-4edb-9577-5b6d8ad0c3a1",
    "title": "Irish nationals in Ukraine casualties"
  },
  {
    "cluster_id": "d316d167-369a-4e0d-ad58-337551778176",
    "title": "Russia accuses West of escalation"
  },
  {
    "cluster_id": "292629c2-32f2-451e-b64e-e8f73bb87975",
    "title": "Nazi-Symbol Tanks Bound for Ukraine"
  },
  {
    "cluster_id": "c99071d0-4f9f-4d85-a471-8ed03007f96c",
    "title": "Coalition pledges unprecedented Ukraine tanks"
  },
  {
    "cluster_id": "35d3d7f4-4964-4980-9833-62b5e004737f",
    "title": "UK Warns Britons; Embassy Relocated"
  },
  {
    "cluster_id": "acde1f80-8000-4b4d-8e9d-7d24f15b41d9",
    "title": "Unidentified drones near Zelensky Dublin visit"
  },
  {
    "cluster_id": "db91531a-0712-431d-a04b-9b798db3d3b4",
    "title": "Refugee Draws Swastika in UK Mall"
  },
  {
    "cluster_id": "3dcf8216-5e70-4cd4-962e-dc4b036a0071",
    "title": "US Refuses Abrams Tanks to Ukraine"
  },
  {
    "cluster_id": "38520096-281c-4b53-ba64-f7e18dbd525f",
    "title": "UN Dissatisfied With Western Tanks"
  },
  {
    "cluster_id": "4575f267-4553-4c7c-916e-359800e4fb24",
    "title": "Wagner destroys Leopard tank, kills crew"
  },
  {
    "cluster_id": "a61f9905-7bda-4da1-b019-fbc601e92e05",
    "title": "Wagner's Bakhmut Role Under Spotlight"
  },
  {
    "cluster_id": "f262ea70-4c26-4dcc-8a1f-52d6f8ce5558",
    "title": "U.S. Poised to Send Abrams Tanks"
  },
  {
    "cluster_id": "d2bc0c3a-3d51-4a76-89f5-0aef4a862a3f",
    "title": "De-escalation urged amid Davos war risk"
  },
  {
    "cluster_id": "88714dc6-72d5-4f7f-9067-219b66b31c42",
    "title": "Swastika Vandalism and Prosecution in London"
  },
  {
    "cluster_id": "e0151ccd-baed-452a-aaa4-6feaeeadc3d9",
    "title": "Abrams Delayed by Training and Logistics"
  },
  {
    "cluster_id": "bc5a19f9-2b61-40ac-ae39-5951370b4cf0",
    "title": "Homes for Ukraine Sponsorship Launched"
  },
  {
    "cluster_id": "3f1ec78d-49c2-44d1-bdc2-97cf6217c638",
    "title": "Germany approves Leopard 2 to Ukraine"
  },
  {
    "cluster_id": "21518841-2c46-4292-abad-aff342a4f1ac",
    "title": "Russia's Denazification Narrative"
  },
  {
    "cluster_id": "de1f8a69-eaff-4387-87ee-35fc20ea4a2f",
    "title": "Poland to close border with Ukraine"
  },
  {
    "cluster_id": "aaa9c952-e937-4295-abaa-c4968a415009",
    "title": "International people-smuggling network dismantled"
  },
  {
    "cluster_id": "e7e80c41-a749-4b0c-a666-715bedd44f52",
    "title": "Poland Refuses Ukrainian Refugees"
  },
  {
    "cluster_id": "f8ba093e-142e-45ae-b5d0-aef007993c05",
    "title": "Poland Opposes EU Migrant Quotas"
  },
  {
    "cluster_id": "3fee6535-a988-4207-9d1e-737120abbcbb",
    "title": "Disinformation about Ukrainian refugees in Poland"
  },
  {
    "cluster_id": "4adc477b-ccba-4820-b5c6-6a663398b338",
    "title": "Border crossings restricted amid transport disputes"
  },
  {
    "cluster_id": "42dcf3d9-1011-484c-9355-4db97109e640",
    "title": "Ukraine Aid Under Electoral Pressure"
  },
  {
    "cluster_id": "3eac5298-75f1-4e1e-94ec-db408d17729a",
    "title": "Ukrainians Decorate Christmas Trees With Swastikas"
  },
  {
    "cluster_id": "9f25d197-8ec1-4d18-aeda-b095d1997826",
    "title": "Poland: Few Syrian Refugees, Anti-Immigrant Rhetoric"
  },
  {
    "cluster_id": "31fb9a7d-5b4f-4fbf-8ec2-a3e65a3978d8",
    "title": "NASA Adjustments Inflate Global Warming"
  },
  {
    "cluster_id": "d5f07507-9281-4cfd-81bd-0fc19ffa8a89",
    "title": "Poles' Support for Ukrainian Refugees Drops"
  },
  {
    "cluster_id": "c021fe18-c42c-443c-8de9-a7f8d58891f4",
    "title": "Wind-Driven Variability Shapes Regional Sea Level"
  },
  {
    "cluster_id": "546b42d0-5005-442c-a548-5a747146aa92",
    "title": "NOAA Releases Regional Sea-Level Rise Tools"
  },
  {
    "cluster_id": "cb5fae82-58a9-4d49-9da8-1886e33d1269",
    "title": "NASA GISS Updates to GISTEMP"
  },
  {
    "cluster_id": "34a8290a-940e-4582-8dbf-cb195db85e28",
    "title": "NOAA Data-Handling Whistleblower Controversy"
  },
  {
    "cluster_id": "2d8a2b96-5e68-43e2-a162-f66eeb390e13",
    "title": "Apparent Slowing in Altimeter Data"
  },
  {
    "cluster_id": "cc1a98ca-fc1c-4f29-b58b-0d99bce8b809",
    "title": "Public Access to Tide Gauge Data"
  },
  {
    "cluster_id": "97ffbb55-ab53-43e7-aa63-34930f97c42a",
    "title": "Uncertainty Over Ukrainian Casualty Figures"
  },
  {
    "cluster_id": "a8acca84-268a-4542-96c5-6e8d1fb747ac",
    "title": "Sea Level Rise: Melt and Expansion"
  },
  {
    "cluster_id": "5beed7c2-e377-4032-9f8d-5e0e7f3ae7e7",
    "title": "Cooling Data, Falsified Warming Graphs"
  },
  {
    "cluster_id": "ca9d7f99-280c-41ec-a4aa-ad1ac5930f8c",
    "title": "Sea Level Rise Not Temperature-Dependent"
  },
  {
    "cluster_id": "f16aab95-d35f-4386-9ea4-6a5f797bcf7f",
    "title": "Escalating Combat in Avdiivka"
  },
  {
    "cluster_id": "80a104b6-58c7-416b-ac35-97712361953c",
    "title": "Defense and Fall of Donetsk Airport"
  },
  {
    "cluster_id": "a9a65207-69ea-45b8-ac25-c8ee16fc4a08",
    "title": "Ukraine military losses revealed"
  },
  {
    "cluster_id": "7e112a5c-41d4-4f1c-b974-99256b5d357b",
    "title": "Europe Considers Russia's Eastern Ukraine Plan"
  },
  {
    "cluster_id": "f78012d1-f500-46ba-802c-d3d1337f7f51",
    "title": "Germany backs phased Russia sanctions lift"
  },
  {
    "cluster_id": "523ae438-64cf-40ea-839d-1a30cbcf4c63",
    "title": "Debaltseve Battle: Ukrainian Withdrawal"
  },
  {
    "cluster_id": "7354cd90-5ded-45c2-af70-b5cea1cc0045",
    "title": "EU Reaffirms and Extends Russia Sanctions"
  },
  {
    "cluster_id": "c786e602-255f-4df8-a9fc-775fc1322fa2",
    "title": "Steinmeier Formula Emerges in Normandy/Minsk Talks"
  },
  {
    "cluster_id": "2b56b1f6-1627-44ab-9460-b13751cf087b",
    "title": "Ilovaisk 2014: Encirclement and Losses"
  },
  {
    "cluster_id": "77cb4584-fbf4-45e6-9a2b-9d46e341c831",
    "title": "Maidan Occupation and Barricades"
  },
  {
    "cluster_id": "505c42ee-a234-45a9-8c74-63207154db3f",
    "title": "Rapid Rise of Volunteer Battalions"
  },
  {
    "cluster_id": "4ac41d40-e8f6-44f4-a7bd-84b0a1d31ea1",
    "title": "Separatists Seize War Spoils"
  },
  {
    "cluster_id": "d10a4ec7-a74e-4016-996b-f1f3a3c6527f",
    "title": "Ukrainian Soldiers Suicide to Avoid Combat"
  },
  {
    "cluster_id": "f0bf7f4c-0a27-4681-9eca-ea221b9315a7",
    "title": "2014 Losses Passed Off as Current Casualties"
  },
  {
    "cluster_id": "93a61a8e-4477-45a4-b63b-bc7992dad11c",
    "title": "Pro-Kremlin Narratives on Ukrainian Demoralization"
  },
  {
    "cluster_id": "ff62f156-1b54-448d-8c41-0514a58493a5",
    "title": "Pro-Russian Seizure of Sloviansk"
  },
  {
    "cluster_id": "906d1526-e5ff-4f4e-a0e5-f30c2dfb306d",
    "title": "Donbas Soldiers' Weekly Suicides"
  },
  {
    "cluster_id": "bd3c25bb-6683-4bdd-8e97-11de485116b2",
    "title": "AFU Brigade Seizes Control After Rally"
  },
  {
    "cluster_id": "5cb4afbf-e109-4c74-8315-a2a58d421c9c",
    "title": "Ukraine GDP Collapse and Hryvnia Plunge"
  },
  {
    "cluster_id": "eab0b5ad-eda0-47fc-89d0-b12331740c85",
    "title": "Congress Turns to Ukraine Aid Oversight"
  },
  {
    "cluster_id": "08ccb8f3-d97c-4442-b830-fac7f751221a",
    "title": "Ukraine: Major Heroin Transit Hub"
  },
  {
    "cluster_id": "241d256c-86d7-484e-8aee-4f2f15316b3d",
    "title": "Cocaine Networks via Ukrainian Ports"
  },
  {
    "cluster_id": "89b0a4a3-f393-4706-9a25-8103c69b53d6",
    "title": "UN OHCHR Killings in Eastern Ukraine"
  },
  {
    "cluster_id": "0c50e809-0f1b-4656-a0dd-110732b6e47b",
    "title": "Ukraine Corruption Soars; Aid Fails"
  },
  {
    "cluster_id": "47f7a131-6ce1-4e01-b64c-61e5f9696bb1",
    "title": "Ukraine: Corruption Perceptions and Rankings"
  },
  {
    "cluster_id": "c9b1ea29-5b23-4579-928f-8f3b1f3679f1",
    "title": "Release of JSOP for Ukraine Response"
  },
  {
    "cluster_id": "a7614301-2ae0-4bb1-bcf4-8bc8d82acc70",
    "title": "Ukraine: Europe\u2019s Poorest Country"
  },
  {
    "cluster_id": "181a2d12-ad30-4552-bb72-ee9a984fa618",
    "title": "Ukraine: Deep Recession, Tough Recovery"
  },
  {
    "cluster_id": "d28f03f1-166f-4e7a-a151-3bb7c1898209",
    "title": "Poverty Surges 2014\u201315, Policy Focus"
  },
  {
    "cluster_id": "b1f3ff2b-9b1f-4366-8ccf-ac47a277ed10",
    "title": "EU Accuses Ukraine of Heroin Flooding"
  },
  {
    "cluster_id": "b777e992-68f2-4307-a472-b1ae2b933a6e",
    "title": "2020 GBR Marine Heatwave and Bleaching Risk"
  },
  {
    "cluster_id": "bd072c00-533b-4c4a-918b-097a11abe63b",
    "title": "UNESCO Recommends Reef in Danger"
  },
  {
    "cluster_id": "f5b1b3d0-19e5-49a1-bbc1-690d440e299c",
    "title": "Regional Increases in Hard Coral Cover"
  },
  {
    "cluster_id": "2e504c36-cc23-49bf-9bfa-77adbeb06137",
    "title": "2019 Global Ocean Heat Content Records"
  },
  {
    "cluster_id": "68637c5d-53b2-4a1b-b193-4fe1333f1416",
    "title": "Coral Reefs Vanish in 35 Years"
  },
  {
    "cluster_id": "dd5764ad-ed57-4067-b6a4-35ca15790cc2",
    "title": "Great Barrier Reef: Record Coral, Safe"
  },
  {
    "cluster_id": "4794bb46-add2-4c57-9ffb-caa8d6c5bb0f",
    "title": "COVID-era tourism decline, clearer reefs"
  },
  {
    "cluster_id": "24603ad6-f39a-4706-80ce-2840439ad61c",
    "title": "Global Coral Bleaching, 2014\u20132016"
  },
  {
    "cluster_id": "76b14a04-38e5-4c33-90b7-69079246c4ac",
    "title": "Reef Recovery Window After Disturbances"
  },
  {
    "cluster_id": "1da0b887-e497-4790-9c97-6324fa7f1453",
    "title": "Australia's Backlash to UNESCO Recommendation"
  },
  {
    "cluster_id": "938b7182-512d-4aa5-a1bc-532c7b55f96a",
    "title": "Europe's 2022 Energy Price Shock"
  },
  {
    "cluster_id": "83578f15-2ee2-4dd4-ae7f-b543ba5e2a87",
    "title": "Barriers to Wind Turbine Blade Recycling"
  },
  {
    "cluster_id": "746085cd-6635-459a-8b25-138f4d67d9dc",
    "title": "Allegations of Ukraine drug trade"
  },
  {
    "cluster_id": "c9335a55-7c59-42cb-98be-e69b4262faa0",
    "title": "Costs and Harms of Wind Turbines"
  },
  {
    "cluster_id": "6efc04ea-c5a7-40f2-bf74-98f55c06f1df",
    "title": "No Change in Reef Temperatures"
  },
  {
    "cluster_id": "efe63a8c-0f9a-4b9f-ad60-14fabb8e67d3",
    "title": "Uri Winter Storm Reveals Texas Grid Failures"
  },
  {
    "cluster_id": "410a0800-e775-4016-b3ff-cc215bfaf3d1",
    "title": "Bird-Smart Wind Farm Advocacy"
  },
  {
    "cluster_id": "31763d96-84ac-402a-a69c-ea748718f342",
    "title": "Raptor Fatalities at Altamont Pass"
  },
  {
    "cluster_id": "0cdd2771-1f79-419e-940c-c74f863377bb",
    "title": "Wind Energy Kills More Birds"
  },
  {
    "cluster_id": "2a7cf868-b485-43d0-b2ff-786617960499",
    "title": "Wind Turbines Kill Eagles, Raise Bills"
  },
  {
    "cluster_id": "89ca7fbd-adb5-4425-9a07-78efe99244cc",
    "title": "Bat Fatalities at Wind Energy Facilities"
  },
  {
    "cluster_id": "fccc5c68-3c5f-4b2d-8103-9431b0c4794a",
    "title": "Rising Demand for Critical Minerals"
  },
  {
    "cluster_id": "12ce4240-07a8-40e1-acc7-141144ad6c5d",
    "title": "Environmental Footprint of Turbine Disposal"
  },
  {
    "cluster_id": "4b620911-0006-4874-ad8a-a8595a7140e4",
    "title": "Painted turbine blades reduce raptor collisions"
  },
  {
    "cluster_id": "05905deb-04e3-4e57-afeb-f4e623c176cb",
    "title": "Final Eagle Incidental-Take Permits for Wind"
  },
  {
    "cluster_id": "fc264446-1206-43b0-b6e2-29d7fc43d99c",
    "title": "Foreign Mercenaries Leave Ukraine for Israel"
  },
  {
    "cluster_id": "7681cbe0-1efe-4edf-b906-ebf02351325e",
    "title": "Estimating Bird Mortality at Wind Turbines"
  },
  {
    "cluster_id": "31351498-4fc3-4c6e-8df2-7c515d19509b",
    "title": "Citizenship Path for Foreign Fighters"
  },
  {
    "cluster_id": "008cba92-e4d7-4655-90ad-12cb214fe197",
    "title": "US Offshore Wind Costs and Cancellations"
  },
  {
    "cluster_id": "ccd586d7-5c30-4f84-8142-adc54ddef655",
    "title": "Analyses Warn of Fringe Foreign Volunteers"
  },
  {
    "cluster_id": "2f12da3e-336e-40d2-ba41-61b838ad70f2",
    "title": "Germany Won't Forcibly Return Ukrainians"
  },
  {
    "cluster_id": "56106773-dee4-4da1-bda2-7227784468b3",
    "title": "Yanukovych assets seized and frozen"
  },
  {
    "cluster_id": "52f03b57-8fb1-4ff1-8eda-c0d228097a8f",
    "title": "Establishment of Ukraine's International Legion"
  },
  {
    "cluster_id": "4c0dfd84-df3b-4660-9041-a635021908ef",
    "title": "Western Grants to Ukrainian Civil Society"
  },
  {
    "cluster_id": "c784871a-fcaa-4345-b3a8-ae8869019499",
    "title": "Ukraine Recruits Mentally Unstable Foreign Fighters"
  },
  {
    "cluster_id": "6a03d110-92cd-4da9-913a-56888b17641f",
    "title": "Ukrainian Expats to Report for Recruitment"
  },
  {
    "cluster_id": "636b2daa-578a-4643-896b-342714f42b34",
    "title": "Titushky Operatives and Employers Identified"
  },
  {
    "cluster_id": "607cc6ab-a0bd-429e-a391-92e1066b96d9",
    "title": "Struggling to Vet, Equip Foreign Fighters"
  },
  {
    "cluster_id": "183ebbd4-8012-4c45-ae37-eee1b7b28721",
    "title": "Paid Pro-Russian Demonstrators in Eastern Ukraine"
  },
  {
    "cluster_id": "64b58fdb-7776-47be-a603-30c85a60366e",
    "title": "German Citizenship via Ukrainian Recruitment"
  },
  {
    "cluster_id": "a5d008c6-c15a-4302-aa70-e916c52f5451",
    "title": "US Invested $5B in Ukraine"
  },
  {
    "cluster_id": "24accb31-401b-42c1-bd69-e81c04cb2530",
    "title": "Paid Participants at Euromaidan"
  },
  {
    "cluster_id": "e18afe50-8e61-4915-8745-6256e6a782cb",
    "title": "Yanukovych Ousted After Euromaidan"
  },
  {
    "cluster_id": "f8cc40a9-e215-46da-bdf5-b5efc622bb40",
    "title": "US Intel Pursued Ukraine Regime Change"
  },
  {
    "cluster_id": "8dd2ae56-dcf0-4439-b3f0-3a7a939056df",
    "title": "California Mandates 25% Urban Water Reductions"
  },
  {
    "cluster_id": "09a3b73e-815c-4ea0-9da8-b1110ca8cf96",
    "title": "Klamath 2002 Fish Kill, Irrigation Disputes"
  },
  {
    "cluster_id": "a07d35a7-6217-400e-856f-516669ebb436",
    "title": "2015 Media Analysis: Stormwater Capture Shortfalls"
  },
  {
    "cluster_id": "5d8665ac-7337-470b-ae27-2d46610e9f97",
    "title": "Yanukovych-Funded Ukrainian Army"
  },
  {
    "cluster_id": "84147a14-72bc-486f-90ad-45e374aeaa05",
    "title": "2017 Wine Country Wildfires"
  },
  {
    "cluster_id": "4141d4f5-ed19-442d-94e2-369926343d5f",
    "title": "Water restrictions worsen California wildfires"
  },
  {
    "cluster_id": "0cb30e02-d84d-4557-96e4-2da52513f036",
    "title": "Oroville Dam Spillway Evacuations"
  },
  {
    "cluster_id": "9e7a0088-26cb-464d-887d-c7e715addbcf",
    "title": "Biological Opinion to Protect Delta Smelt"
  },
  {
    "cluster_id": "ce398b7c-c3fa-42df-8862-5c57ac63cf98",
    "title": "Delta Water Exports Curtailed for Smelt"
  },
  {
    "cluster_id": "28df4744-3bf2-4a43-80dc-d2bea8f7af7a",
    "title": "California Announces First-Ever Urban Water Restrictions"
  },
  {
    "cluster_id": "dc0f2fc6-867e-476a-b8e1-8031edcf72a7",
    "title": "Donetsk Bus-Stop Shelling Kills Civilians"
  },
  {
    "cluster_id": "38dbd9f2-4706-4ca9-a837-817a4ee621f8",
    "title": "Civilian Casualties in Mariupol Shelling"
  },
  {
    "cluster_id": "ecb3f4fd-fe1b-4ef4-a13b-94c4c7eea90e",
    "title": "Donetsk: Rising Fatalities and Urban Combat"
  },
  {
    "cluster_id": "0fde95b6-db57-45cd-b6ac-fb0edd1b186b",
    "title": "Ukrainian Forces Shell Donetsk"
  },
  {
    "cluster_id": "253fbf69-01a5-4352-a109-1aea0fdf1fe3",
    "title": "Heroine debunked as Donetsk victim"
  },
  {
    "cluster_id": "2bd231ca-b95f-4da8-b52c-5b92d58eef4f",
    "title": "OSCE Reports Mariupol Jan 24 Shelling"
  },
  {
    "cluster_id": "468c9eea-e420-4271-9b73-0e2e747f6185",
    "title": "Deforestation increases pandemic vulnerability"
  },
  {
    "cluster_id": "bc23e70d-7b5e-43f0-97b5-b24c31beffb6",
    "title": "OSCE SMM: 29 Killed This Year"
  },
  {
    "cluster_id": "3a969b37-0ab9-41ab-b145-dd3f362c8638",
    "title": "Grave human rights abuses in Ukraine"
  },
  {
    "cluster_id": "37ac1c3c-10ae-411e-a6f7-5a4e0cfd6c1b",
    "title": "Youth-Led Global Climate Strikes"
  },
  {
    "cluster_id": "36f68109-962e-490e-9101-85d84c5de66a",
    "title": "Volcanic CO2 Challenges Global Warming Theory"
  },
  {
    "cluster_id": "0f3a2cc5-8301-476a-b658-747594635542",
    "title": "Predicted Global Mass Death"
  },
  {
    "cluster_id": "1ae95d89-cea7-4f27-8ed8-d4f49e95c5db",
    "title": "Climate Is Always Changing"
  },
  {
    "cluster_id": "e47ab492-3177-49bc-9493-e444a1518298",
    "title": "Volcanic CO2 dwarfed by human emissions"
  },
  {
    "cluster_id": "5ef68f23-0f9c-4c57-af44-b6d2b7f6107c",
    "title": "Natural Orbital Changes Drive Warming"
  },
  {
    "cluster_id": "c92757d9-a065-4dc2-806f-96c7c9890f76",
    "title": "China Bans Wildlife Trade Nationwide"
  },
  {
    "cluster_id": "8ec6c014-24e3-40b5-a577-20ca128d6e41",
    "title": "Huanan Market Linked to Early Cases"
  },
  {
    "cluster_id": "98a5a190-c887-4ce2-b53f-011c39183ade",
    "title": "Etna Eruption Emits 10,000x CO2"
  },
  {
    "cluster_id": "c2350485-f95c-46d4-9b92-6355ceca86df",
    "title": "29 Civilians Killed in Donbas"
  },
  {
    "cluster_id": "145aa4e5-4dc7-4a0e-a117-12b6a5547a63",
    "title": "IPCC 1.5\u00b0C Special Report Released"
  },
  {
    "cluster_id": "273cff70-66df-48dd-9efa-69156787ee64",
    "title": "IPBES Biodiversity and Ecosystem Services Assessment"
  },
  {
    "cluster_id": "ba793871-eeec-487b-a1b0-5996d1bd03cf",
    "title": "UN Warns of Approaching Tipping Point"
  },
  {
    "cluster_id": "921c5a51-cef0-491b-8b5f-a5f05c5b785f",
    "title": "Calbuco 2015: Quantified Gas/Ash Emissions"
  },
  {
    "cluster_id": "94a3af2d-ef6e-49ef-84ee-4d1aa3f90aff",
    "title": "Same Experts, Contradictory Climate Claims"
  },
  {
    "cluster_id": "933d50c3-dd0d-4b5f-9957-22bbcfcc55d5",
    "title": "Ohio Enacts Heartbeat Protection Law"
  },
  {
    "cluster_id": "3e1920d2-6038-4d0b-b122-137c458f6d99",
    "title": "Bat-Eating Caused Wuhan Outbreak"
  },
  {
    "cluster_id": "7db64556-43b7-4e29-b1a9-e8fcd5d29233",
    "title": "2\u00b0C: Irreversible Tipping Point"
  },
  {
    "cluster_id": "2ff5212c-713e-4d80-b0b9-c7f306cf69fb",
    "title": "Alabama Near-Total Abortion Ban"
  },
  {
    "cluster_id": "3e95ef61-306a-4cf0-a217-5b910e8ffc01",
    "title": "CMS EMTALA Guidance for Pregnant Patients"
  },
  {
    "cluster_id": "c8ac3f5f-f7f9-419c-9873-a9fbc34aa61a",
    "title": "Abortions Are Not Medically Necessary"
  },
  {
    "cluster_id": "a08d6d8c-3534-4503-908a-ad9b08709410",
    "title": "Post-Dobbs Emergency Care Guidance"
  },
  {
    "cluster_id": "27c3b9de-4f86-4091-b50b-7314a2636d6c",
    "title": "GAO Audit of FDA Mifeprex Decisions"
  },
  {
    "cluster_id": "4df23607-a04c-40e8-be3f-b8d874dc3d06",
    "title": "Lawsuit Challenges Mifepristone Approval"
  },
  {
    "cluster_id": "0c951d24-0f2c-41e0-a5be-f5200eceb7d7",
    "title": "FDA Paused In-Person Dispensing"
  },
  {
    "cluster_id": "d4bc60e5-da16-45c3-909d-aa14379adeb2",
    "title": "Foreign Fighter Flows to Syria"
  },
  {
    "cluster_id": "8a84554f-19d7-41fa-8647-c3608df3d4f1",
    "title": "Turkey's Euphrates Shield Offensive"
  },
  {
    "cluster_id": "bcbfb3b5-386e-4a9d-9149-63379d147048",
    "title": "Turkey Accused of Allowing Foreign Fighters"
  },
  {
    "cluster_id": "9cef1461-4ccb-4b2f-8a1e-1d71ef404be6",
    "title": "Alaska Court voids Medicaid abortion criteria"
  },
  {
    "cluster_id": "b7e82711-b99a-4580-8fb1-a7b6465b462b",
    "title": "Pro-Life Clinicians: Abortion Not Medically Necessary"
  },
  {
    "cluster_id": "b5cfe764-3a89-4e77-9f9e-c720d7d22394",
    "title": "Dobbs Overturns Roe, Debate Intensifies"
  },
  {
    "cluster_id": "a66a05dd-2f9d-47e7-8c3b-f3a662bda0e0",
    "title": "Mifepristone: Unsafe, Harms Health"
  },
  {
    "cluster_id": "b7518287-9949-4ec0-a078-3d7e49009d46",
    "title": "Russian Media Links Ukraine, Syria"
  },
  {
    "cluster_id": "9917626e-0afd-495f-82cd-6e27aa8cc73d",
    "title": "Global Crimean Tatars Unite Against Annexation"
  },
  {
    "cluster_id": "6c806f4f-f4b8-4c40-ad97-ff6d0d5a2a84",
    "title": "Chechen Fighters in Donbas and Syria"
  },
  {
    "cluster_id": "789c4f9a-6863-49ee-a41c-e12949429992",
    "title": "Crimean Tatars Fought in Syria"
  },
  {
    "cluster_id": "c8d47411-ab85-4f96-b286-cd76451823f8",
    "title": "Turkey Builds Caliphate in Southern Ukraine"
  },
  {
    "cluster_id": "54bf8eb2-6975-454f-a48b-59abffdfe4f4",
    "title": "Jihadists at Crimean Tatar World Congress"
  },
  {
    "cluster_id": "b9cee305-a96d-440f-a08d-e2f6545e2608",
    "title": "Turkey backs Ukraine and Crimean Tatars"
  },
  {
    "cluster_id": "b7e33865-58b2-4984-a7e1-eed1512539bb",
    "title": "Ukrainians to Join Syrian War"
  }
]